import { validate4NumberDigits } from '../../../../utils/form-utils';
import { FormattedMessage } from 'react-intl';
import React from 'react';

export const CONFIG_BOOKKEEPING = [
  {
    header: <FormattedMessage id="page.administration.bookkeeping.outgoingVAT" defaultMessage="Outgoing VAT" />,
    fields: [
      {
        name: 'VatOut25',
        label: <FormattedMessage id="page.administration.bookkeeping.numberVAT" defaultMessage={`{number}% VAT`}
                                 values={{ number: 25 }} />,
        validate: validate4NumberDigits,
      },
      {
        name: 'VatOut12',
        label: <FormattedMessage id="page.administration.bookkeeping.numberVAT" defaultMessage={`{number}% VAT`}
                                 values={{ number: 12 }} />,
        validate: validate4NumberDigits,
      },
      {
        name: 'VatOut6',
        label: <FormattedMessage id="page.administration.bookkeeping.numberVAT" defaultMessage={`{number}% VAT`}
                                 values={{ number: 6 }} />,
        validate: validate4NumberDigits,
      },
    ],
  },
  {
    fields: [
      {
        header: <FormattedMessage id="page.administration.bookkeeping.invoicing" defaultMessage="Invoicing" />,
        fields: [
          {
            name: 'CustomerDebts',
            label: <FormattedMessage id="page.administration.bookkeeping.customerInvoicing"
                                     defaultMessage="Customer invoicing" />,
            validate: validate4NumberDigits,
          },
        ],
      },
      {
        header: <FormattedMessage id="page.administration.bookkeeping.skulder" defaultMessage="Debts" />,
        fields: [
          {
            name: 'GiftCardsUnused',
            label: <FormattedMessage id="page.administration.bookkeeping.unusedGiftcard"
                                     defaultMessage="Unused giftcards" />,
            validate: validate4NumberDigits,
          },
        ],
      },
      {
        header: <FormattedMessage id="page.administration.bookkeeping.otherItems" defaultMessage="Other items" />,
        fields: [
          {
            name: 'GiftCardsEmptied',
            label: <FormattedMessage id="page.administration.bookkeeping.emptiedGiftcards"
                                     defaultMessage="Emptied giftcards" />,
            validate: validate4NumberDigits,
          },
        ],
      },
    ],
  },
  {
    header: <FormattedMessage id="page.administration.bookkeeping.salesStandard" defaultMessage="Sales, standard" />,
    fields: [
      {
        name: 'SalesVat25',
        label: <FormattedMessage id="page.administration.bookkeeping.salesNumberVAT"
                                 defaultMessage={'Sales, {number}% VAT'} values={{ number: 25 }} />,
        validate: validate4NumberDigits,
      },
      {
        name: 'SalesVat12',
        label: <FormattedMessage id="page.administration.bookkeeping.salesNumberVAT"
                                 defaultMessage={'Sales, {number}% VAT'} values={{ number: 12 }} />,
        validate: validate4NumberDigits,
      },
      {
        name: 'SalesVat6',
        label: <FormattedMessage id="page.administration.bookkeeping.salesNumberVAT"
                                 defaultMessage={'Sales, {number}% VAT'} values={{ number: 6 }} />,
        validate: validate4NumberDigits,
      },
      {
        name: 'SalesVat0',
        label: <FormattedMessage id="page.administration.bookkeeping.salesDutyfree" defaultMessage="Sales, Dutyfree" />,
        validate: validate4NumberDigits,
      },
      {
        name: 'ExcludedItems',
        label: <FormattedMessage id="page.administration.bookkeeping.salesExcluded" defaultMessage="Sales, excluded" />,
        validate: validate4NumberDigits,
      },
    ],
  },
];

export const CONFIG_BOOKKEEPING_NEXT_STEP = [
  {
    header: <FormattedMessage id="page.administration.bookkeeping.payments" defaultMessage="Payments" />,
    fields: [
      {
        name: 'Cash',
        label: <FormattedMessage id="page.administration.bookkeeping.cash" defaultMessage="Cash" />,
        validate: validate4NumberDigits,
      },
      {
        name: 'BankAccount',
        label: <FormattedMessage id="page.administration.bookkeeping.bankAccount" defaultMessage="Bank account" />,
        validate: validate4NumberDigits,
      },
      { name: 'Card', label: <FormattedMessage id="page.administration.bookkeeping.card" defaultMessage="Card" /> },
      {
        name: 'Coupon',
        label: <FormattedMessage id="page.administration.bookkeeping.coupon" defaultMessage="Coupon" />,
        validate: validate4NumberDigits,
      },
      { name: 'ExternalOrder', label: 'Webshop', validate: validate4NumberDigits },
      { name: 'Swish', label: 'Swish', validate: validate4NumberDigits },
      { name: 'Klarna', label: 'Klarna', validate: validate4NumberDigits },
      {
        name: 'OtherPayment',
        label: <FormattedMessage id="page.administration.bookkeeping.other" defaultMessage="Other" />,
        validate: validate4NumberDigits,
      },
    ],
  },
  {
    header: <FormattedMessage id="page.administration.bookkeeping.others" defaultMessage="Others" />,
    fields: [
      {
        name: 'CashFloatDifference',
        label: <FormattedMessage id="page.administration.bookkeeping.cashDifference"
                                 defaultMessage="Cash difference" />,
        validate: validate4NumberDigits,
      },
      {
        name: 'Rounding',
        label: <FormattedMessage id="page.administration.bookkeeping.roundingOre" defaultMessage="Rounding, öre" />,
        validate: validate4NumberDigits,
      },
      {
        name: 'Tip',
        label: <FormattedMessage id="page.administration.bookkeeping.tips" defaultMessage="Tips" />,
        validate: validate4NumberDigits,
      },
      {
        name: 'RecyclingDeposit',
        label: <FormattedMessage id="page.administration.bookkeeping.recyclingDeposit"
                                 defaultMessage="Recycling Deposit" />,
        validate: validate4NumberDigits,
      },
    ],
  },
  {
    header: <FormattedMessage id="page.administration.bookkeeping.cardType" defaultMessage="Cardtype" />,
    fields: [
      { name: 'Amex', label: 'Amex', validate: validate4NumberDigits },
      { name: 'Diners', label: 'Diners', validate: validate4NumberDigits },
    ],
  },
];